import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Shared "we'll be right back" / "launching soon" page — the customer-facing half
 * of the Gate 2 "we are in business" switch.
 *
 * Rendered for EVERY route when an app is built with `MAINTENANCE_MODE=true`
 * (see `withMaintenanceMode` + each app's `app.config.ts`). It is purely
 * presentational: no router, no auth, no store — so it renders even when the rest
 * of the app would fail to bootstrap, and stays trivially testable.
 *
 * Named `Service`Maintenance to avoid colliding with the operator app's unrelated
 * truck-maintenance `MaintenanceComponent`.
 */
@Component({
  selector: 'bodyanalytics-service-maintenance',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  templateUrl: './service-maintenance.component.html',
  styleUrl: './service-maintenance.component.scss',
})
export class ServiceMaintenanceComponent {
  /** Headline — defaults to a launch-friendly message; hosts may override. */
  readonly heading = input<string>('Launching soon');

  /** Supporting copy under the headline. */
  readonly message = input<string>("We're putting the finishing touches on your experience. Check back shortly.");
}
